import Field from "./_Field";

export default class SelectField extends Field
{

  tomSelectInstance = null;

  constructor(form, el, config) {
    super(form, el, config);
    if (this.el.dataset.tomselect){
      this.initTomSelect()
    }
  }

  static findAllFieldsInForm(form){
    const selectsEls =  form.querySelectorAll('select');
    const selects = {};
    for (let el of selectsEls){
      selects[ el.name.replaceAll('[]', '') ] = el;
    }
    return selects;
  }

  initTomSelect() {
    this.waitForTomSelect().then(() => {
      this.tomSelectInstance = new TomSelect(this.el);
    })
  }

  waitForTomSelect(){
    return new Promise((resolve, reject) => {
      const timer = setInterval(() => {
        if (typeof TomSelect !== 'undefined') {
          clearInterval(timer);
          resolve()
        }
      }, 200);
    })
  }


  getValue(){
    if (this.el.multiple){
      const selectedOptions = this.el.querySelectorAll('option:checked');
      if (!selectedOptions.length) return undefined;
      return [...selectedOptions]
          .map((opt) => opt.value)

    } else {
      if (this.el.value !== '') return this.el.value;
      return undefined;
    }
  }

  getContainer(){
    return this.el.closest('.Form__group')
  }

  getLabel(){
    return this.getContainer().querySelector('label')
  }
}
